import React from 'react';
import { connect } from 'dva';
import SerachHelper, { ISearchResult } from './serachHelper';
import routeConfig from '../../../abs/config/routeConfig';
import ABSMessage from '../../ABSMessage';
import commonUtils from '../../../utils/commonUtils';
import ABSGlobalSearchView from './GlobalSearchView';
import { IABSGlobalSearchProps } from '../interface';

export interface IABSSearchBarState {
  loading: boolean;
  keyword: string;
  isOpen: boolean;
  isSelect: boolean;
  results: Array<ISearchResult>;
}

class ABSGlobalSearch extends React.Component<IABSGlobalSearchProps, IABSSearchBarState> {
  time; // 定时器
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      isOpen: false,
      isSelect: false,
      keyword: '',
      results: []
    };
  }

  componentDidMount() {
    document.addEventListener('click', (e: any) => {
      this.clearState();
    });

    const keyword = commonUtils.getParams().keyword;
    if (keyword) {
      this.setState({ keyword });
    }
  }

  clearState = () => {
    this.setState({
      loading: false,
      isOpen: false,
      isSelect: false,
      results: []
    });
  }

  handleKeyDown = (e) => {
    const code = e.charCode || e.keyCode;
    if (code === 13) {
      const { isSelect, keyword } = this.state;
      // 键盘Enter事件时跳转搜索结果页（选中弹窗中的条目和搜索框没有Focus时不触发）
      if (isSelect === false) {
        const { onKeyDown } = this.props;
        if (onKeyDown) {
          clearTimeout(this.time);
          this.setState({ isOpen: false });
          onKeyDown(keyword);
        }
      }
    }
  }

  onFocus = (e) => {
    const { keyword } = this.state;
    const { isSearch } = this.props;

    document.addEventListener('keydown', this.handleKeyDown);
    if (isSearch !== false) {
      this.timeoutSearch(keyword);
    }
  }

  onBlur = (e) => {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  // 搜索值改变时发起搜索
  onSearch = (value) => {
    this.setState({ keyword: value });
    this.timeoutSearch(value);
  }

  // 搜索设置1s间隔，防止频繁发起请求
  timeoutSearch = (value) => {
    clearTimeout(this.time);

    const serachValue = value.trim();
    if (serachValue === '') {
      this.setState({ keyword: '', loading: false, isOpen: false, results: [] });
      return;
    }

    this.time = setTimeout(() => this.searchResult(serachValue), 1000);
  }

  // 发起搜索请求
  searchResult = (serachValue) => {
    let pathname = window.location.pathname;
    const rootPath = process.env.REACT_APP_PUBLISH_PATH;
    if (rootPath) {
      pathname = pathname.replace(rootPath, '');
    }
    const url = pathname + window.location.hash;
    this.setState({ loading: true });

    this.props.dispatch({
      type: 'global/search',
      payload: {
        keyword: serachValue,
        url: url,
      }
    }).then((response) => {
      this.setState({
        loading: false,
      });

      if (!response) {
        return;
      }

      this.setState({
        isOpen: true,
        results: SerachHelper.parseResults(response),
      });
    });
  }

  // 选中时
  onSelect = (value, option) => {
    this.setState({ isSelect: true });
    const { size } = this.props;
    if (size === 'small') {
      window.open(option.key);
    } else {
      location.href = option.key;
    }
  }

  // 跳转搜索结果页面
  onGoMore = (keyword: string) => {
    if (keyword === '') {
      ABSMessage.warning('请输入要查询的内容！');
      return;
    }
    window.location.href = `${routeConfig.search}?keyword=${keyword}`;
  }

  render() {
    const { size, className, placeholder } = this.props;
    const { results, isOpen, loading, keyword } = this.state;

    return (
      <ABSGlobalSearchView
        className={className}
        dropdownClassName="abs-search-dropdown"
        size={size}
        results={results}
        loading={loading}
        keyword={keyword}
        placeholder={placeholder}
        isOpen={isOpen}
        onSelect={this.onSelect}
        onSearch={this.onSearch}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      />
    );
  }
}

function mapStateToProps(state: any) {
  return { ...state.global, loading: state.loading.effects['global/search'] };
}

export default connect(mapStateToProps)(ABSGlobalSearch);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSearch/GlobalSearch/index.tsx